import * as React from "react"
import { useState } from "react";
import { navigate } from "gatsby"
import { TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, CircularProgress, Button, Snackbar } from "@material-ui/core"
import MuiAlert from '@material-ui/lab/Alert';
import firebase from "gatsby-plugin-firebase"


import ImgLogo from "../images/logo.png"

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const Register = () => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validated, setValidated] = useState(false);


    let createAccount = async () => {
        if (!email || !password) {
            setValidated(true);
            return;
        }

        setLoading(true);

        try {
            let res = await firebase.auth().signInWithEmailAndPassword(email, password);
            if (res.user)
                navigate("/dashboard", { replace: true });

        } catch (e) {
            console.log(e);
            setSnackbarMessage(e.message);
            setSnackbarOpen(true);
        }
        setLoading(false);
    }

    return (
        <main className="min-h-screen flex justify-center items-center pb-16 md:py-10" style={{ backgroundColor: "rgb(242,245,251)" }}>
            <div className="w-full md:w-1/3 shadow-xl bg-white">
                <img src={ImgLogo} alt="UWILD logo" className="w-16 h-16 mx-10 mt-6" />
                <h1 className="text-3xl text-gray-400 px-10 pt-6">Login</h1>
                <p className="text-sm font-medium text-gray-600 px-10 pb-6">Sign into your UWILD Dasboard</p>
                <hr />

                <div className="px-8 py-8 flex flex-wrap">

                    <div className="w-full py-2 px-2">
                        <TextField
                            id="email"
                            size="small"
                            label="Email Address"
                            fullWidth
                            type="email"
                            variant="outlined"
                            value={email}
                            error={validated && !email}
                            helperText={validated && !email ? "Email cannot be empty" : ""}
                            disabled={loading}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="w-full px-2 py-2">
                        <TextField
                            id="password"
                            size="small"
                            label="Password"
                            fullWidth
                            type="password"
                            variant="outlined"
                            value={password}
                            error={validated && !password}
                            helperText={validated && !password ? "Password cannot be empty" : ""}
                            disabled={loading}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                </div>
                <div className="py-4 shadow-inner shadow-md cursor-pointer hover:shadow-sm uppercase text-sm font-bold 
                text-white tracking-wide text-center bg-blue-500" onClick={() => {
                        if (loading) return;
                        createAccount();
                    }}>
                    {loading ? (<CircularProgress size={30} color="white" />) : "Register"}
                </div>
            </div>

            <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)}>
                <Alert onClose={() => setSnackbarOpen(false)} severity="error">
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </main>
    )
}

export default Register;